import React from "react";
import { useState } from "react";
import Button from "./button";

export function BotaoGerarRelatorio(props) {
    const [hover, setHover] = useState(false);

    return (
        <div className="w-100 d-flex justify-content-center" onMouseEnter={() => setHover((prev) => true)} onMouseLeave={() => setHover((prev) => false)}>
            {hover && props.gerarXlsx ? (
                <>
                    <Button
                        title="Imprime os dados listados em PDF"
                        disabled={props.aguardando}
                        startHover={false}
                        icon="fas fa-file-pdf"
                        text={<span style={{ fontSize: "0.75rem" }}>Gerar PDF</span>}
                        type={"primary"}
                        event={() => {
                            props.gerarPdf();
                            setHover((prev) => false);
                        }}
                        style={{ margin: "0px 2px 0px 0px" }}
                    />
                    <Button
                        title="Baixa uma planilha do excel com os dados listados na tabela"
                        disabled={props.aguardando}
                        startHover={false}
                        icon="fas fa-file-excel"
                        text={<span style={{ fontSize: "0.75rem" }}>Gerar XLS</span>}
                        type={"success"}
                        event={() => {
                            props.gerarXlsx();
                            setHover((prev) => false);
                        }}
                        style={{ margin: "0px 0px 0px 2px" }}
                    />
                </>
            ) : (
                <Button
                    title="Imprime os dados listados"
                    disabled={props.aguardando}
                    text={
                        <div style={{ padding: 8 }}>
                            <i className="fas fa-print pr-2"></i>Imprimir Relatório
                        </div>
                    }
                    type={"info"}
                    style={{ padding: 0 }}
                    event={props.gerarPdf}
                />
            )}
        </div>
    );
}
